import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["className", "children", "visibilityHeight", "click", "target", "character", "clsPrefix"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../wui-icon/src';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  visibilityHeight: PropTypes.number,
  click: PropTypes.func,
  target: PropTypes.func
};
var defaultProps = {
  visibilityHeight: 400,
  click: function click() {},
  target: function target() {
    return window;
  },
  character: /*#__PURE__*/React.createElement(Icon, {
    type: "uf-top-up"
  })
};
var BackTop = (_dec = WebUI({
  name: "back-top",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(BackTop, _Component);

  var _super = _createSuper(BackTop);

  function BackTop(props) {
    var _this;

    _classCallCheck(this, BackTop);

    _this = _super.call(this, props);
    _this.state = {
      show: false
    };
    _this.click = _this.click.bind(_assertThisInitialized(_this));
    _this.scroll = _this.scroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BackTop, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scroll();
    }
  }, {
    key: "scroll",
    value: function scroll() {
      var self = this;

      this.props.target().onscroll = function () {
        if ((self.props.target().scrollY || self.props.target().scrollTop) >= self.props.visibilityHeight) {
          self.setState({
            show: true
          });
        } else {
          self.setState({
            show: false
          });
        }
      };
    }
  }, {
    key: "click",
    value: function click() {
      var _this2 = this;

      var height = this.props.target().scrollY || this.props.target().scrollTop;

      var timer = function timer(height) {
        var self = _this2;
        var h = Math.floor(height / 3);
        self.props.target().scrollTo ? self.props.target().scrollTo(0, h) : self.props.target().scrollTop = h;

        if (h > 0) {
          window.clearInterval(window.backTopTimer);
          window.backTopTimer = window.setInterval(function () {
            timer(h);
          }, 90);
        } else {
          _this2.setState({
            show: false
          });

          window.clearInterval(window.backTopTimer);
          return;
        }
      };

      timer(height);
      this.props.click();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          visibilityHeight = _this$props.visibilityHeight,
          click = _this$props.click,
          target = _this$props.target,
          character = _this$props.character,
          clsPrefix = _this$props.clsPrefix,
          others = _objectWithoutProperties(_this$props, _excluded);

      className = className ? className : '';
      className = !this.state.show ? "".concat(clsPrefix, " ").concat(clsPrefix, "-hide ") + (target() === window ? '' : "".concat(clsPrefix, "-dom ")) + className : "".concat(clsPrefix, " ") + (target() === window ? '' : "".concat(clsPrefix, "-dom ")) + className;
      return /*#__PURE__*/React.createElement("span", _extends({}, others, {
        className: className,
        onClick: this.click
      }), children ? children : this.props.character);
    }
  }]);

  return BackTop;
}(Component)) || _class);
;
BackTop.propTypes = propTypes;
export default BackTop;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-backtop/src/BackTop.js